import React from "react";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Home,
  DollarSign,
  BarChart3,
  Target,
  BookOpen,
  GraduationCap,
} from "lucide-react";

interface NavItem {
  path: string;
  icon: React.ComponentType<{ className?: string }>;
  label: string;
}

const navItems: NavItem[] = [
  { path: "/dashboard", icon: Home, label: "Início" },
  { path: "/transactions", icon: DollarSign, label: "Transações" },
  { path: "/charts", icon: BarChart3, label: "Gráficos" },
  { path: "/goals", icon: Target, label: "Metas" },
  { path: "/finance-school", icon: GraduationCap, label: "Escolinha" },
  { path: "/education", icon: BookOpen, label: "Educação" },
];

const BottomNavigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <motion.nav
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.3, delay: 0.2 }}
      className="fixed bottom-0 left-0 right-0 bg-dark-800/95 backdrop-blur-sm border-t border-dark-700 z-50 md:hidden"
    >
      <div className="flex justify-around items-center py-1 px-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;

          return (
            <motion.button
              key={item.path}
              onClick={() => navigate(item.path)}
              whileTap={{ scale: 0.95 }}
              className={`flex flex-col items-center py-2 px-1 sm:px-2 rounded-lg transition-colors min-w-0 flex-1 ${
                isActive
                  ? "text-primary-400 bg-primary-400/10"
                  : "text-gray-400 hover:text-white"
              }`}
            >
              <item.icon className="w-4 h-4 sm:w-5 sm:h-5 mb-0.5 sm:mb-1" />
              <span className="text-[10px] sm:text-xs font-medium truncate">
                {item.label}
              </span>
              {isActive && (
                <motion.div
                  layoutId="activeTab"
                  className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-primary-400 rounded-full"
                />
              )}
            </motion.button>
          );
        })}
      </div>
    </motion.nav>
  );
};

export default BottomNavigation;
